<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M9.06445 15.145C9.06445 12.3166 9.06445 10.9024 9.94313 10.0237C10.8219 9.14502 12.2361 9.14502 15.0645 9.14502H16.0645C18.8929 9.14502 20.3071 9.14502 21.1858 10.0237C22.0645 10.9024 22.0645 12.3166 22.0645 15.145V16.145C22.0645 18.9734 22.0645 20.3876 21.1858 21.2663C20.3071 22.145 18.8929 22.145 16.0645 22.145H15.0645C12.2361 22.145 10.8219 22.145 9.94313 21.2663C9.06445 20.3876 9.06445 18.9734 9.06445 16.145V15.145Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.0644 9.14502C17.062 6.18793 17.0173 4.65623 16.1565 3.60745C15.9903 3.40491 15.8046 3.2192 15.6021 3.05298C14.4957 2.14502 12.852 2.14502 9.56445 2.14502C6.27697 2.14502 4.63323 2.14502 3.52688 3.05298C3.32434 3.21919 3.13863 3.40491 2.97241 3.60745C2.06445 4.7138 2.06445 6.35754 2.06445 9.64502C2.06445 12.9325 2.06445 14.5762 2.97241 15.6826C3.13862 15.8851 3.32434 16.0708 3.52688 16.237C4.57566 17.0978 6.10736 17.1425 9.06445 17.1449"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>